export const setArrayByDateMethod = (date_method: string) => {
  return function (title: any[]) {
    // 表格头
    if (date_method !== 'aggregated') {
      title.push('Date');
    }
    return title;
  };
};
// 设置固定表头
export const setTitleByFixed = (titleItem: any) => {
  return function (title: any[]) {
    // 表格头
    title.push({
      title: titleItem.title,
      key: titleItem.valueKey,
    });
    return title;
  };
};
export const setTitleByDateMethod = (date_method: string) => {
  return function (title: any[]) {
    // 表格头
    if (date_method !== 'aggregated') {
      title.push({
        title: 'Date',
        key: 'date',
      });
    }
    return title;
  };
};

const AlignDateModeTitlesBuilders: Record<string, (titles: any[]) => any[]> = {
  aggregated: (titles: any[]) => {
    if (!Array.isArray(titles) || titles.length === 0) return [];
    const dateRangeTitles = [
      {
        title: 'Start Date',
        key: 'start_release_time',
        formatter: 'align_release_start_date',
      },
      {
        title: 'End Date',
        key: 'start_release_time',
        formatter: 'align_release_end_date',
      },
    ];
    Array.prototype.push.apply(titles, dateRangeTitles);
    return titles;
  },
  separate: (titles: any[]) => {
    if (!Array.isArray(titles) || titles.length === 0) return [];
    const dateTitle = {
      title: 'Date',
      key: 'date',
      formatter: 'align_release_date',
    };
    titles.push(dateTitle);
    return titles;
  },
};

export const setAlignDateModeTitlesByDateMethod = (dateMethod: string) => {
  return (titles: any[]) => {
    const buildAlignModeTitles = AlignDateModeTitlesBuilders[dateMethod];
    return buildAlignModeTitles?.(titles) || titles;
  };
};

export const setTitlesByDateMethod = (isAlignToRelease = false, dateMethod = 'separate') => {
  if (!isAlignToRelease) return setTitleByDateMethod(dateMethod);
  return setAlignDateModeTitlesByDateMethod(dateMethod);
};

export const setArrayByRegionMethod = (region_method: string) => {
  return function (title: any[]) {
    if (region_method === 'region') {
      title.push('Region_Chinese', 'Region_English');
    } else if (region_method === 'market') {
      title.push(
        'Region_Chinese',
        'Region_English',
        'Country_Chinese',
        'Country_English',
      );
    }
    return title;
  };
};
export const setTitleByRegionMethod = (
  region_method: string,
  isOnlyMarket = false,
) => {
  return function (title: any[]) {
    if (region_method === 'region') {
      title.push(
        ...[
          {
            title: 'Region_Chinese',
            key: 'region_chinese',
          },
          {
            title: 'Region_English',
            key: 'region_english',
          },
        ],
      );
    } else if (region_method === 'market') {
      if (isOnlyMarket) {
        title.push(
          ...[
            {
              title: 'Market_Chinese',
              key: 'country_chinese',
            },
            {
              title: 'Market_English',
              key: 'country_english',
            },
          ],
        );
      } else {
        title.push(
          ...[
            {
              title: 'Region_Chinese',
              key: 'region_chinese',
            },
            {
              title: 'Region_English',
              key: 'region_english',
            },
            {
              title: 'Country_Chinese',
              key: 'country_chinese',
            },
            {
              title: 'Country_English',
              key: 'country_english',
            },
          ],
        );
      }
    }
    return title;
  };
};
export const setArrayByEditionMethod = (edition_method: string) => {
  return function (title: any[]) {
    // 表格头
    if (edition_method !== 'aggregated') {
      title.push('Edition Id', 'Edition Name', 'Platform');
    }
    return title;
  };
};
export const setItem = (params: Record<string, any>) => {
  const { item } = params;
  if (item.Source === 'appannie') {
    item.Source = 'data.ai';
  }
  return {
    ...params,
    item,
  };
};
function getMetricTitle(
  metric: string,
  metricTitleMap: Record<string, string>,
): string {
  // Prefer exact match first (e.g. "gamalytic__pcu") to avoid losing meaning
  // when normalizing by "__".
  if (metricTitleMap?.[metric]) return metricTitleMap[metric];

  // Then normalize some prefixed metric keys like "databrain__total_revenue" or "mscience__digitalRevenue"
  // to their base metric key before lookup so labels resolve correctly.
  // If no prefix exists, fall back to the original key.
  const normalizedMetric =
    typeof metric === 'string' && metric.includes('__')
      ? metric.split('__').pop() || metric
      : metric;
  return metricTitleMap[normalizedMetric] || normalizedMetric;
}
export const setMetricTitle = (
  metricTitleMap: Record<string, any>,
  dateType?: string,
  type?: string,
) => {
  return function (params: Record<string, any>) {
    const { item, title } = params;
    let metricTitle = getMetricTitle(item.Metric, metricTitleMap);
    if (item.Metric === 'dau') {
      if (dateType === 'monthly') {
        metricTitle = 'MAU';
      } else if (dateType === 'weekly') {
        metricTitle = 'WAU';
      }
    }

    if (metricTitle?.length === 0) {
      metricTitle = `${item.Metric}(${item.Source})`;
      if (item?.Segment?.length > 0) {
        metricTitle = `${metricTitle}(${item.Segment})`;
      }
    } else if (item.Source === 'stream') {
      metricTitle += `(${getMetricTitle(item.Platform, metricTitleMap)})`;
    } else {
      if (item.Source) {
        metricTitle += `(${item.Source})`;
      }
      if (item?.Segment?.length > 0) {
        metricTitle = `${metricTitle}(${item.Segment === 'All' ? 'Aggregated' : item.Segment})`;
      }
    }
    if (type === 'isObject') {
      title.push({
        title: metricTitle,
        key: `${item.Metric}${item?.Segment?.length ? `@#${item.Segment}` : ''}`,
      });
    } else {
      title.push(metricTitle);
    }
    return {
      ...params,
      metricTitle,
    };
  };
};
const excludeMetrics = [
  'rpd',
  'cumulative_revenue',
  'cumulative_downloads',
  'cumulative_download',
  'meta_score',
];
export const setPercent = (params: Record<string, any>) => {
  const { item, title } = params;

  if (!excludeMetrics.includes(item.Metric)) {
    title.push('%');
  }
  return params;
};
export const setPercentForPCConsole = (
  radioShow: any,
  radioValue = 'growth_ratio',
) => {
  if (!radioShow) return () => {};
  return (params: Record<string, any>) => {
    const { item, title } = params;
    if (!excludeMetrics?.includes(item?.Metric)) {
      if (item?.Metric?.indexOf('meta_score') === -1)
        title.push({
          title: '%',
          key: `${item.Metric}${item?.Segment?.length ? `@#${item.Segment}` : ''}@#${radioValue}`,
        });
    }
    return params;
  };
};
export const getTitleByDateType = (dateType: string): string => {
  let sheetName = 'Stats';
  switch (dateType) {
    case 'daily':
      sheetName += '-Daily';
      break;
    case 'weekly':
      sheetName += '-Weekly';
      break;
    case 'monthly':
      sheetName += '-Monthly';
      break;
  }
  return sheetName;
};

export const setTitleByCompanyShow = (company_show: any) => {
  return (title: any) => {
    if (company_show == '1') {
      title.push(
        ...[
          { title: 'Publisher Company Name', key: 'publisher' },
          {
            title: 'Publisher Company HQ Name',
            key: 'publisher_addr_full_name',
          },
          { title: 'Publisher Parent Company', key: 'parent_publisher' },
          { title: 'Developer Company Name', key: 'developer' },
          {
            title: 'Developer Company HQ Name',
            key: 'developer_addr_full_name',
          },
          { title: 'Developer Parent Company', key: 'parent_developer' },
        ],
      );
    }
    return title;
  };
};

export const setTitleByPublisherClassShow = (publisher_class_show: any) => {
  return (title: any) => {
    if (publisher_class_show == '1') {
      title.push({ key: 'publisher_class', title: 'Publisher Class' });
    }
    return title;
  };
};

export const setTitleByGenreShow = (genre_show: any) => {
  return (title: any) => {
    if (genre_show == '1') {
      title.push(
        ...[
          {
            title: 'IEGG Main Genre',
            key: 'iegg_genre',
          },
          {
            title: 'IEGG Sub Genre',
            key: 'iegg_sub_genre',
          },
        ],
      );
    }
    return title;
  };
};
export const setTitleByMainGenreShow = (genre_method: any) => {
  return (title: any) => {
    if (genre_method === 'parentGenre') {
      title.push(
        ...[
          {
            title: 'Genre',
            key: 'genre',
          },
        ],
      );
    }
    return title;
  };
};
export const setTitleByReleaseDateShow = (release_date_show: any) => {
  return (title: any) => {
    if (release_date_show == '1') {
      title.push({
        title: 'Release Date',
        key: 'release_time',
      });
    }
    return title;
  };
};
export const setTitleBySteamIdShow = (steam_id_show: any) => {
  return (title: any) => {
    if (steam_id_show == '1') {
      title.push({
        title: 'Steam ID',
        key: 'steam_id',
      });
    }
    return title;
  };
};
export const setTitleBySteamTagsShow = (steam_tag_show: any) => {
  return (title: any) => {
    if (steam_tag_show == '1') {
      title.push({
        title: 'Steam Tags',
        key: 'steam_tag',
      });
    }
    return title;
  };
};
export const setTitleByGameModeShow = (game_mode_show: any) => {
  return (title: any) => {
    if (game_mode_show == '1') {
      title.push({
        title: 'Game Modes',
        key: 'game_mode',
      });
    }
    return title;
  };
};
export const setTitleByGameEngineShow = (game_engine_show: any) => {
  return (title: any) => {
    if (game_engine_show == '1') {
      title.push({
        title: 'Game Engine',
        key: 'game_engine',
        formatter: 'game_engine',
      });
    }
    return title;
  };
};
export const setTitleBySupportedPlatformsShow = (platform_show: any) => {
  return (title: any[]) => {
    if (platform_show === 1 || platform_show === '1') {
      title.push({
        title: 'Supported Platforms',
        key: 'platform',
        formatter: 'supported_platforms',
      });
    }
    return title;
  };
};
export const setTitleByPlatform = (device_method: any) => {
  return function (title: any[]) {
    // 表格头
    if (device_method !== 'aggregated') {
      title.push({
        title: 'Platform',
        key: 'platforms',
      });
    }
    if (device_method === 'device') {
      title.push({
        title: 'Device',
        key: 'device',
      });
    }
    return title;
  };
};
export const setGameTitle = (title: any[]) => {
  title.push({
    title: 'Game Name',
    key: 'name',
  });
  return title;
};
export const setTitleByRegionShow = (region_show: any) => {
  return (title: any) => {
    if (region_show == '1') {
      title.push(
        ...[
          {
            title: 'Country_Chinese',
            key: 'country_chinese',
          },
          {
            title: 'Country_English',
            key: 'country_english',
          },
        ],
      );
    }
    return title;
  };
};
export const setDateTitle = (isTable: boolean) => {
  return (title: any[]) => {
    if (!isTable) {
      title.push({
        title: 'Date',
        key: 'date',
      });
    }
    return title;
  };
};
export const setNewTitleByCompanyShow = (company_show: any) => {
  return (title: any) => {
    if (company_show == '1') {
      title.push(
        ...[
          { title: 'Company Name', key: 'publisher' },
          { title: 'Company HQ', key: 'publisher_addr_full_name' },
          { title: 'Company HQ Name', key: 'parent_publisher' },
          { title: 'Parent Company', key: 'parent_developer' },
        ],
      );
    }
    return title;
  };
};
